export default __webpack_public_path__ + "static/media/Windows.4ac4555b.png";